module.exports = ({
    "CDMS970TT001": "ประวัติการรวม eConsent",
    "CDMS970H001": "No.",
    "CDMS970H002": "รหัสผู้ใช้",
    "CDMS970H003": "ชื่อผู้ใช้งาน",
    "CDMS970H004": "วันที่เริ่มต้น",
    "CDMS970H005": "วันที่สิ้นสุด",
    "CDMS970H006": "รหัสสถานวิจัย",
    "CDMS970H007": "รหัสผู้เข้าร่วมวิจัย",
    "CDMS970H008": "วันที่ลงทะเบียน",
    "CDMS970H009": "สถานะ",
    "CDMS970H010": "รายละเอียด",
    "CDMS970OPT001": "อยู่ระหว่างดำเนินการ",
    "CDMS970OPT002": "สำเร็จ",
    "CDMS970OPT003": "ไม่สำเร็จ",
    "CDMS970MSG001": "ไม่มีโทเคน (Token)",
    "CDMS970MSG002": "โทเคน (Token) หมดอายุแล้ว",
    "CDMS970MSG003": "ไม่มีสิทธิ์ในการเชื่อมโยง eConsent ของการศึกษา {study_id} ด้วยรหัสผู้ใช้งาน (User ID) นี้",
    "CDMS970MSG004": "ไม่มีสิทธิ์ในการเชื่อมโยง eConsent ของสถานวิจัย {site_id} ด้วยรหัสผู้ใช้งาน (User ID) นี้",
    "CDMS970MSG005": "ยังไม่ได้ระบุรหัสการศึกษา (Study ID)",
    "CDMS970MSG006": "ไม่พบการศึกษา {study_id} ในระบบ CDMS",
    "CDMS970MSG007": "การศึกษา {study_id} ยังไม่ได้ตั้งค่าเชื่อมโยงกับ eConsent",
    "CDMS970MSG008": "สถานะของการศึกษา {study_id} คือ DB Lock (ฐานข้อมูลถูกล็อก)",
    "CDMS970MSG009": "ยังไม่ได้ระบุรหัสสถานวิจัย (Site ID)",
    "CDMS970MSG010": "ไม่พบสถานวิจัย {site_id} ในการศึกษา {study_id}",
    "CDMS970MSG011": "สถานวิจัย {site_id} ยังไม่ได้ตั้งค่าเชื่อมโยงกับ eConsent",
    "CDMS970MSG012": "สถานะของสถานวิจัย {site_id} คือ ”ลบ” หรือ ”ปิดใช้งาน”",
    "CDMS970MSG013": "การซิงโครไนซ์ข้อมูลผู้เข้าร่วมวิจัยตามคำขอเสร็จสิ้นแล้ว",
    "CDMS970MSG014": "ยังไม่ได้ระบุรหัสผู้เข้าร่วมวิจัยการศึกษา (Subject ID)",
    "CDMS970MSG015": "รหัสผู้เข้าร่วมวิจัย (Subject ID) {subject_id} มีอยู่ในสถานวิจัยอื่นแล้ว",
    "CDMS970MSG016": "รหัสผู้เข้าร่วมวิจัย (Subject ID) {subject_id} มีอักขระที่ไม่สามารถใช้ได้",
    "CDMS970MSG017": "โปรดกรอกรหัสผู้เข้าร่วมวิจัย (Subject ID) {subject_id} ไม่เกิน 256 ตัวอักษร",
    "CDMS970MSG018": "รหัสผู้เข้าร่วมวิจัย (Subject ID) {subject_id} จะถูกข้าม เนื่องจากผู้เข้าร่วมวิจัยอยู่ในสถานวิจัยแล้ว",
    "CDMS970MSG019": "ไม่สามารถสร้างผู้เข้าร่วมวิจัย {subject_id} ได้ เนื่องจากมี Open query",
    "CDMS970MSG020": "กรุณากรอกวันที่ให้ความยินยอม (Consent date)",
    "CDMS970MSG021": "รูปแบบของวันที่ให้ความยินยอม (Consent date) ไม่ถูกต้อง",
    "CDMS970MSG022": "ค่าของวันที่ให้ความยินยอมไม่ถูกต้อง",
    "CDMS970MSG023": "คุณไม่ถูกกำหนดสิทธิ์ในการสร้างผู้เข้าร่วมวิจัยในไซต์ {site_id}",
    "CDMS970MSG024": "คุณไม่ถูกกำหนดสิทธิ์ในการดำเนินการกับการศึกษา {study_id}",
    "CDMS970MSG025": "ยังไม่ได้ระบุวันที่ให้ความยินยอม (Consent Date) ในหน้าลงทะเบียน",
    "CDMS970MSG026": "ช่องวันที่ให้ความยินยอมถูกลบหรือถูกยกเว้น",
    "CDMS500BTN001": "รายการผู้เข้าร่วมวิจัย",
    "CDMS400MSG003": "ไม่พบหน้าลงทะเบียน",
    "CDMS400MSG004": "มีการตั้งค่าหน้าลงทะเบียนหลายหน้า",
    "CDMS400MSG005": "ไม่มีการตั้งค่าหมายเลขคัดกรองในหน้าลงทะเบียน",
    "CDMS400MSG008": "ไม่สามารถลงทะเบียนเข้าร่วมวิจัยได้ เนื่องจากเวอร์ชันของไซต์ยังไม่ได้ตั้งค่าอย่างถูกต้อง",
    "CDMS400MSG010": "หมายเลขการลงทะเบียนต้องน้อยกว่าหรือเท่ากับ 256 อักขระ",
    "CDMS401MSG003": "ไม่สามารถเพิ่ม ENRNUM อัตโนมัติได้",
    "COMMSG002": "เกิดข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ",
    "COMMSG011": "กำลังนำเข้าข้อมูลจาก StudyBuilder กรุณารอสักครู่"
});
